import React, { useEffect, useState, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { TableBaseStyle } from './PartialDischargeCollectionStyle';

type PartialDischargeCollectionFooterProps = {
    onClickSaveButton: () => void;
    onClickCancelButton: () => void;
    buttonEnable: boolean;
}

const PartialDischargeCollectionFooter: React.FC<PartialDischargeCollectionFooterProps> = (props: PartialDischargeCollectionFooterProps) => {
    const { t } = useTranslation();
    const tableStyle = TableBaseStyle();

    return (
        <Grid
            container
            justify="flex-start"
            spacing={1}
            direction="row"
            alignItems="center"
            style={{ width: 'calc(100vw - 12px)' }}
        >
            <Grid item xs={2}>
                <Button
                    className={tableStyle.buttonStyle}
                    variant="contained"
                    color="primary"
                    disabled={!props.buttonEnable}
                    onClick={(e) => {
                        props.onClickSaveButton();
                    }}
                >
                    {t('PartialDischargeCollectionFooter.保存', '保存')}
                </Button>
            </Grid>
            <Grid item xs={2}>
                <Button
                    className={tableStyle.buttonStyle}
                    variant="contained"
                    color="primary"
                    disabled={!props.buttonEnable}
                    onClick={(e) => props.onClickCancelButton()}
                >
                    {t('PartialDischargeCollectionFooter.キャンセル', 'キャンセル')}
                </Button>
            </Grid>
        </Grid>
    )

}
export default PartialDischargeCollectionFooter;